module.exports = __webpack_public_path__ + "img/SMSC15109-min.978b6a70.png";